export const channelTypes = {
  SMS: 0,
  MMS_EMAIL: 1,
  TWITTER: 2,
  FB: 3,
  FACEBOOK: 3,
  GPLUS: 4,
  MIXIT: 5,
  WE_CHAT: 6,
  WEB_HOOK: 7,
  USSD: 8,
  WHATSAPP: 9,
  INSTAGRAM: 10,
  CELLFIND: 11,
  TELEGRAM: 12,
  WHATSAPPWEB: 13,
  DMS: 15,
  INFOBIP: 16,
  MTECH: 17,
  SMS_TRUMPIA: 18,
  SURVEY: 19,
  'DATA IMPORT': 20,
  BUMBLEBEE: 21,
  TIKTOK: 22,
};

export const activityTypes = {
  NOTE_TYPE: 0,
  PERCENT_TYPE: 1,
};



// WEBPACK FOOTER //
// ./src/constants.js